<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <h1 class="text-center">Agenda del día</h1>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" class="mt-4">
      <v-col cols="auto">
        <v-btn icon @click="cambiarDia(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="8">
        <v-text-field v-model="fechaSeleccionada" type="date" readonly class="text-center"></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn icon @click="cambiarDia(1)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mt-4" style="overflow-y: auto; max-height: 500px;">
      <v-col cols="12" v-if="loading" class="d-flex justify-center align-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
      <v-col cols="12" v-else v-for="tarea in tareasComputed" :key="tarea.id">
        <v-card
          :color="getCardColor(tarea.state)"
          class="pa-4"
          @click="tarea.state === 10 ? abrirPopupCambiarEstado(tarea) : null"
        >
          <v-row align="center">
            <v-col cols="3" class="d-flex justify-center align-center">
              <div class="text-h5 font-weight-bold">{{ tarea.hora }}</div>
            </v-col>
            <v-col cols="1">
              <v-divider vertical class="mx-2" style="height: 60px;"></v-divider>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1">{{ tarea.building_desc }}</div>
              <div class="text-subtitle-2">{{ tarea.user_name }}</div>
              <div class="text-subtitle-2">{{ tarea.cleaner ? tarea.cleaner.name : '' }}</div>
            </v-col>
            <v-col cols="2" class="d-flex justify-end align-center">
              <v-icon v-if="tarea.sheets_cleaned === 1" color="primary" class="mr-2">mdi-bed</v-icon>
              <v-icon v-if="tarea.towels_cleaned === 1" color="primary">mdi-shower</v-icon>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="popupCambiarEstado" max-width="500px">
      <v-card>
        <v-card-title class="justify-center">Cambiar estado</v-card-title>
        <v-card-text>
          <p>Inquilino: {{ tareaSeleccionada.user_name }}</p>
          <p>Vivienda: {{ tareaSeleccionada.building_desc }}</p>

          <v-select
            v-model="nuevoEstado"
            :items="[
              { text: 'Completado', value: 20 },
              { text: 'Ausente', value: 15 },
              { text: 'Problema', value: 90 }
            ]"
            label="Nuevo estado"
          ></v-select>
          <div v-if="nuevoEstado === 20" class="mt-4">
            <v-row>
              <v-col cols="6">
                <v-btn text @click="toggleSheets" class="w-100">
                  <v-icon :color="sheets_cleaned ? 'primary' : 'grey'" class="mr-2">mdi-bed</v-icon>
                  <span :class="sheets_cleaned ? 'primary--text' : 'grey--text'">Sábanas</span>
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn text @click="toggleTowels" class="w-100">
                  <v-icon :color="towels_cleaned ? 'primary' : 'grey'" class="mr-2">mdi-shower</v-icon>
                  <span :class="towels_cleaned ? 'primary--text' : 'grey--text'">Toallas</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-textarea v-if="nuevoEstado === 90" v-model="motivoProblema" label="Motivo del problema"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="popupCambiarEstado = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="actualizarEstado">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      fechaSeleccionada: new Date().toISOString().substr(0, 10),
      loading: false,
      tareas: [],
      popupCambiarEstado: false,
      tareaSeleccionada: {},
      nuevoEstado: null,
      sheets_cleaned: 0,
      towels_cleaned: 0
    }
  },
  async mounted() {
    await this.getCleanerDay()
  },
  computed: {
    ...mapGetters({
      userCleaner: 'loginCleaner/userCleaner'
    }),
    tareasComputed() {
      return this.tareas.map(tarea => ({
        ...tarea,
        user_name: `${tarea.user.name} ${tarea.user.last_name.charAt(0)}.`,
        hora: new Date(tarea.date).toLocaleTimeString('es-ES', {
          hour: '2-digit',
          minute: '2-digit'
        })
      }))
    }
  },
  methods: {
    ...mapActions({
      getSchedule: 'cleaning/getCleanerScheduleDay',
      saveState: 'cleaning/saveState',
      addAlert: 'alerts/add'
    }),
    toggleSheets() {
      this.sheets_cleaned = this.sheets_cleaned ? 0 : 1
    },
    toggleTowels() {
      this.towels_cleaned = this.towels_cleaned ? 0 : 1
    },
    cambiarDia(delta) {
      const fecha = new Date(this.fechaSeleccionada)
      fecha.setDate(fecha.getDate() + delta)
      this.fechaSeleccionada = fecha.toISOString().substr(0, 10)
      this.getCleanerDay() // Llamar a getCleanerDay aquí
    },
    async getCleanerDay() {
      try {
        this.loading = true
        let response = await this.getSchedule({
          day: this.fechaSeleccionada,
          id: this.userCleaner.id
        })
        this.tareas = response
      } catch (e) {
        this.addAlert({ text: e, color: 'error' })
        return
      } finally {
        this.loading = false
      }
    },
    getCardColor(state) {
      switch (state) {
        case 15:
          return 'amber lighten-4' // Amarillo pastel
        case 90:
          return 'red lighten-4' // Rojo pastel
        case 20:
          return 'green lighten-4' // Verde pastel
        default:
          return 'grey lighten-5' // Gris muy claro
      }
    },
    abrirPopupCambiarEstado(tarea) {
      this.tareaSeleccionada = tarea
      this.sheets_cleaned = 0
      this.towels_cleaned = 0
      this.popupCambiarEstado = true
    },
    async actualizarEstado() {
      try {
        this.loading = true
        await this.saveState({
          state: this.nuevoEstado,
          sheets_cleaned: this.sheets_cleaned,
          towels_cleaned: this.towels_cleaned,
          motivo: this.motivoProblema == '' ? null : this.motivoProblema,
          id: this.tareaSeleccionada.id
        })
        this.getCleanerDay()
      } catch (e) {
        this.addAlert({ text: e, color: 'error' })
        return
      } finally {
        this.loading = false
      }
      // Aquí puedes llamar al backend para actualizar el estado de la tarea
      this.popupCambiarEstado = false
    }
  },
  watch: {
    fechaSeleccionada() {
      this.getCleanerDay()
    }
  }
}
</script>
